var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0166 0.0556641C10.7525 0.0556641 0.00012207 11.0979 0.00012207 24.7195C0.00012207 38.3411 10.7525 49.3833 24.0166 49.3833C37.2807 49.3833 48.0331 38.3411 48.0331 24.7195C48.0331 11.0979 37.2807 0.0556641 24.0166 0.0556641ZM18.1376 34.9421H13.2742V18.8695H18.1376V34.9421ZM15.6759 16.8964C14.1398 16.8964 13.1466 15.7788 13.1466 14.3966C13.1466 12.9862 14.1698 11.902 15.7384 11.902C17.307 11.902 18.2677 12.9862 18.2977 14.3966C18.2977 15.7788 17.307 16.8964 15.6759 16.8964ZM35.8998 34.9421H31.0364V26.0349C31.0364 23.9616 30.3309 22.5537 28.5722 22.5537C27.2288 22.5537 26.4308 23.5068 26.078 24.424C25.9479 24.7503 25.9154 25.2128 25.9154 25.6726V34.9396H21.0496V23.995C21.0496 21.9885 20.987 20.3108 20.922 18.867H25.1474L25.37 21.0996H25.4676C26.108 20.0513 27.6766 18.5047 30.3009 18.5047C33.5006 18.5047 35.8998 20.7065 35.8998 25.4388V34.9421V34.9421Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cb77ae39c2938743ab6dc07c4a7006e0.svg";
export { ForwardRef as ReactComponent };